module.exports = "fragment DetailedGroupFragment on Group {\n  __typename\n  id\n  name\n  description\n  members {\n    ...ContactFragment\n  }\n}\n"